import React from "react";
import "tippy.js/dist/tippy.css";
import IconButton from "./IconButton";
import { useTranslation } from 'react-i18next';

const XButton = ({show = true, onClick, tooltip}) => {

    const { t } = useTranslation();

    return (
        <>
            <IconButton
                variant="outline-secondary"
                size="sm"
                className="btn-circle border-none"
                role="button"
                icon="fa-x"
                tooltip={tooltip || t("common.delete")}
                onClick={onClick}
            />
        </>
    );
};


export default XButton;